import React, { Component } from "react";
import {
  Circle,
  CircleMarker,
  Map,
  Marker,
  Polygon,
  Popup,
  Rectangle,
  TileLayer,
  Tooltip,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default class SimpleExample extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lat: 12.965564,
      lng: 77.6005882,
      zoom: 12,
    };
  }

  render() {
    const position = [this.state.lat, this.state.lng];
    return (
      <section
        style={{
          position: "relative",
          height: "50vh",
          overflow: "hidden",
          margin: "1rem",
        }}
      >
        <header>Previous Office Locations</header>
        <Map
          center={position}
          zoom={this.state.zoom}
          style={{ height: "inherit" }}
        >
          <TileLayer
            attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={position}>
            <Popup>Sonata Software</Popup>
          </Marker>
          <Marker position={[12.973659, 77.7165751]}>
            <Popup>Capgemini</Popup>
          </Marker>
        </Map>
      </section>
    );
  }
}
